import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { StyledText } from '../../../Atoms/Typography/index.styles';
export var HighlightedStyledDay = function HighlightedStyledDay(props) {
  return "\n    &:before {\n        height: 24px;\n        width: 24px;\n    }\n\n    ".concat(StyledText, " {\n        z-index: 1;\n        color: ").concat(props.theme.components.calendar.daysSelectedText, ";\n        font-weight: ").concat(props.theme.components.calendar.dayFontWeight, ";\n    }\n");
};
export var StyledDay = styled.div(_templateObject(), function (props) {
  return "\n        position: relative;\n        cursor: pointer;\n        width: ".concat(100 / 7, "%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-left: ").concat(props.offset * (100 / 7), "%;\n        margin-bottom: ").concat(props.theme.components.calendar.daysMargin, ";\n        user-select: none;\n\n        ").concat(StyledText, " {\n            font-weight: ").concat(props.theme.components.calendar.dayFontWeight, ";\n        }\n\n        &:before {\n            position: absolute;\n            content: '';\n            height: 0;\n            width: 0;\n            background: ").concat(props.theme.components.calendar.daysSelectedBackground, ";\n            border-radius: 3px;\n            transition: ").concat(props.theme.components.calendar.daysTransition, ";\n        }\n\n        & > * {\n            z-index: 1;\n            margin: 0;\n        }\n\n        ").concat(props.holiday ? "\n                    ".concat(StyledText, " {\n                        color: ").concat(props.theme.components.calendar.holidayColor, ";\n                    }\n                ") : '', "\n\n        &:hover {\n            ").concat(HighlightedStyledDay(props), "\n        }\n\n        ").concat(props.selected ? HighlightedStyledDay(props) : '', "\n    ");
});
export var StyledWeekDays = styled.div(_templateObject2(), function (props) {
  return "\n        display: flex;\n        width: 100%;\n        margin: ".concat(props.theme.components.calendar.weekDaysMargin, ";\n\n        & > * {\n            margin: 0;\n            width: ").concat(100 / 7, "%;\n            display: flex;\n            color: ").concat(props.theme.components.calendar.weekDaysColor, ";\n            justify-content: center;\n        }\n    ");
});
export var StyledDays = styled.div(_templateObject3(), function (props) {
  return "\n        color: ".concat(props.theme.components.calendar.unselected, ";\n\n        display: flex;\n        flex-wrap: wrap;\n    ");
});